import {
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IInputMethodBehaviorSpecifiable, instanceOfIInputMethodBehaviorSpecifiable,
  ITurnedTextStyleSpecifiable, instanceOfITurnedTextStyleSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { IStandardTextDrawableObject, instanceOfIStandardTextDrawableObject } from "./IStandardTextDrawableObject";

export interface ITagObject extends
IStandardTextDrawableObject,
IEditBehaviorSpecifiable,
IInputMethodBehaviorSpecifiable,
ITurnedTextStyleSpecifiable {
  // TODO: 独自要素の実装.
}

export function instanceOfITagObject(instance: any): instance is ITagObject {
  return instance
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIInputMethodBehaviorSpecifiable(instance)
      && instanceOfIStandardTextDrawableObject<ITagObject>(instance, "tag")
      && instanceOfITurnedTextStyleSpecifiable(instance);
}
